import React from 'react';

import { MCButton, OtpField, TextField } from 'src/components/basic';
import BaseComponent from 'src/components/BaseComponent';
import AuthContainer from 'src/components/AuthContainer';

import {
  withRouter,
  scssVariables as variables,
  lang,
  formatDuration,
  permissions
} from 'src/helpers';

import model from './model';
import LANG_CONST from 'src/helpers/lang/const';

let intervalId = 'PhoneVerification';

class PhoneVerification extends BaseComponent {
  state = { resend: false };
  componentDidMount() {
    model.subscribe(this.subscription);
    this.init();
  }

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
  }

  init = () => {
    if (model.state.user?.phoneNumberVerified) {
      console.log('PhoneVerification: phoneNumberVerified');
      return permissions.afterLogin(model.state.user);
    }

    model.resetApiState('sendOTP');
    model.resetApiState('verifyOTP');
    this.timer(() => model.state.resetExpired > Date.now(), intervalId);
  };

  sendOTP = (e) => {
    e.preventDefault();
    model.sendOTP((error, res) => {
      if (res?.ok) {
        this.setState({ resend: false });
      } else if (res?.expired) {
        model.setState({ resetExpired: res.expired });
        this.timer(() => model.state.resetExpired > Date.now(), intervalId);
      }
    });
  };

  verifyOTP = (e) => {
    e.preventDefault();
    model.verifyOTP((error, res) => {
      if (res?.ok) {
        let emailVerificationRequired = false;
        if (res.user) {
          model.emit('profile', res.user);
        }
        if (this.props.next) {
          this.props.next();
        } else if (emailVerificationRequired) {
          this.navigate(permissions.PAGES.EMAIL_VERIFICATION_PAGE.path);
        } else {
          this.navigate('/');
          setTimeout(() => {
            model.emit('showSignupPopup');
          }, 100);
        }
      } else if (res?.expired) {
        model.setState({ resetExpired: res.expired });
        this.timer(() => model.state.resetExpired > Date.now(), intervalId);
      }
    });
  };

  renderCodeInput = () => {
    const apiStateId = 'verifyOTP';
    const { handleChange } = model;
    const createState = model.getApiState(apiStateId);
    let { invalid, errorMessage, error, loading } = createState;

    const { blocked, expiredIn } = model.getBlock();

    if (error === 'BLOCKED') errorMessage = '';
    if (['INVALID_CODE', 'EXPIRED_CODE'].includes(error)) {
      invalid['code'] = errorMessage;
      errorMessage = '';
    }

    return (
      <>
        {createState.error && <p className='mc-error'>{errorMessage}</p>}
        <form className='mc-form' onSubmit={this.verifyOTP}>
          <OtpField
            template={6}
            name={'code'}
            type='opt'
            inputType={'tel'}
            value={model.input('code').toString()}
            onChange={handleChange}
            label={LANG_CONST.verification_code}
            invalid={invalid}
            numInputs={model.state.codeLength}
            containerStyle={{
              flex: 1,
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between'
            }}
          />
          <MCButton
            large
            type='submit'
            radius
            disabled={blocked || loading}
            loading={loading}
            primary
            dark={!blocked}
            light={blocked}
            label={
              blocked
                ? lang.t(LANG_CONST.buttons.verification_in, {
                    duration: formatDuration(expiredIn)
                  })
                : lang.t(LANG_CONST.buttons.verify)
            }
          />

          <div className='mc-label-420'>
            <span className=''>{lang.t(LANG_CONST.notice.no_receive_code)} </span>{' '}
            <span
              onClick={() => {
                model.resetApiState('verifyOTP');
                model.setState({ code: '' });
                this.setState({ resend: true });
              }}
              style={{ color: variables['colors-mc-primary'], cursor: 'pointer' }}
            >
              {lang.t(LANG_CONST.buttons.click_to_resend)}
            </span>
          </div>
        </form>
      </>
    );
  };
  renderPhoneInput = () => {
    const apiStateId = 'sendOTP';
    const { handleChange, handleBlur } = model;
    const createState = model.getApiState(apiStateId);
    let { invalid, error, errorMessage, loading } = createState;

    const { blocked, expiredIn } = model.getBlock();

    if (error === 'BLOCKED') errorMessage = '';

    if (error === 'PHONENUMBER_TAKEN') {
      invalid['phoneNumber'] = errorMessage;
      error = '';
    }

    let blockedInMin = Math.ceil(expiredIn / 60);
    blockedInMin = `${blockedInMin} ${blockedInMin > 2 ? 'minutes' : 'minute'}`;

    return (
      <>
        {error && <p className='mc-error'>{errorMessage}</p>}
        <form className='mc-form' onSubmit={this.sendOTP}>
          <TextField
            template={6}
            defaultCountryName={model.state.countryName}
            name={'phoneNumber'}
            type='phone'
            value={model.input('phoneNumber')}
            onChange={(n, v) => {
              model.resetApiState(apiStateId);
              model.setStateSilent({ resetExpired: 0 });
              handleChange(n, v);
            }}
            onBlur={handleBlur}
            label={LANG_CONST.phone_number}
            invalid={invalid}
          />
          {blocked && (
            <div className={'mc-label-418'}>
              {lang.t(LANG_CONST.notice.verify_code_sent_phone, { blockedInMin })}
            </div>
          )}
          <MCButton
            large
            type='submit'
            radius
            disabled={blocked || loading}
            loading={loading}
            primary
            dark={!blocked}
            light={blocked}
            label={
              blocked
                ? lang.t(LANG_CONST.buttons.resend_in, { duration: formatDuration(expiredIn) })
                : lang.t(LANG_CONST.buttons.resend)
            }
          />
        </form>
      </>
    );
  };

  render() {
    return (
      <AuthContainer>
        <div className={'mc-page-auth-box'}>
          <div className={'mc-box-header'}>
            <h4 className='mc-box-title'>{lang.t('Phone verification')}</h4>
          </div>
          {this.state.resend ? this.renderPhoneInput() : this.renderCodeInput()}
        </div>
      </AuthContainer>
    );
  }
}

export default withRouter(PhoneVerification);
